import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Meter } from '../../../models/meter.model';

export interface WithdrawConsentDialogData {
  meters: Meter[];
}

@Component({
  selector: 'app-withdraw-consent-dialog',
  templateUrl: './withdraw-consent-dialog.component.html',
  styleUrls: ['./withdraw-consent-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule
  ]
})
export class WithdrawConsentDialogComponent {
  
  constructor(
    public dialogRef: MatDialogRef<WithdrawConsentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WithdrawConsentDialogData
  ) {}

  get meters(): Meter[] {
    return this.data.meters;
  }

  get isSingleMeter(): boolean {
    return this.meters.length === 1;
  }

  get hasShares(): boolean {
    return this.meters.some(meter => this.getPlatformShares(meter).length > 0);
  }

  get metersWithShares(): Meter[] {
    return this.meters.filter(meter => this.getPlatformShares(meter).length > 0);
  }

  get totalSharesCount(): number {
    return this.metersWithShares.reduce((total, meter) => {
      return total + this.getPlatformShares(meter).length;
    }, 0);
  }

  getPlatformShares(meter: Meter) {
    return meter.shareeNames?.filter(share => share.shareType === 'platform') || [];
  }

  onConfirm(): void {
    this.dialogRef.close({ action: 'confirm' });
  }

  onManageShares(): void {
    this.dialogRef.close({ action: 'manage-shares', meter: this.meters[0] });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  getShareIcon(shareType: string): string {
    switch (shareType) {
      case 'platform':
        return 'business';
      case 'email':
        return 'email';
      case 'link':
        return 'link';
      default:
        return 'share';
    }
  }
}
